<template>
  <v-row justify="center" v-if="recibo">
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <v-toolbar-title
            >Edicion de Recibo <span v-if="recibo"> N° 000{{ recibo.nro_recibo }}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="py-2" v-if="recibo.id">
          <v-form ref="vform" v-model="formValid" lazy-validation>
            <v-container>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-select
                    v-model="form.forma"
                    :items="formas_pago"
                    :rules="[rules.required]"
                    item-text="nombre"
                    outlined
                    dense
                    label="Forma de Pago"
                    return-object
                  ></v-select>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-menu v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :rules="[rules.required]"
                        readonly
                        label="Fecha de Pago"
                        v-model="form.fecha_pago"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" locale="es-ES" @input="menu1 = false" :max="maxDate()"></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field v-model.trim="form.nombre_depositante" outlined dense :rules="[rules.required]" label="Nombre de Depositante"></v-text-field>
                </v-col>
                <v-col cols="6" class="py-0">
                  <v-text-field v-model.trim="form.num_doc_depositante" :rules="[rules.dni]" outlined dense label="C.I. de Depositante"></v-text-field>
                </v-col>
                <template v-if="form.forma && form.forma.id == 2">
                  <v-col cols="6" class="py-0">
                    <v-select
                      v-model="form.cuenta"
                      :items="cuentas_bancarias"
                      item-text="nombre"
                      outlined
                      dense
                      :rules="[rules.required]"
                      label="N° de Cuenta Bancaria"
                      return-object
                    ></v-select>
                  </v-col>
                  <v-col cols="6" class="py-0">
                    <v-text-field
                      v-model="form.num_comprobante"
                      :rules="[rules.required]"
                      outlined
                      dense
                      label="N° Comprobante/Bancarizacion/deposito"
                      hint="Numero de comprobante/Bancarizacion/deposito de la tranferencia realizado en la entidad bancaria o Tigo Money."
                    ></v-text-field>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider class="my-0"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" rounded @click="saveForm"> <v-icon class="mx-1">mdi-content-save</v-icon> Guardar </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog"> Cancelar <v-icon> mdi-close</v-icon> </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import xaxios from '@/xaxios';
import gql from 'graphql-tag';
import { formatDate } from '@/components/Utils';

export default {
  data() {
    return {
      rules: {
        // dni: (v) => /^[1-9]\d{4,14}(-([A-Z0-9]{1,2}))?$/.test(v) || 'Numero de Documento no válido',
        dni: (v) => /^[1-9](\d|-(?!\\-))*\d{3,13}(-([A-Z0-9]{1,2}))?$/.test(v) || 'Numero de Documento no válido',
        required: (value) => !!value || 'Campo Obligatorio',
        minValue: (str) => (!!str && str.length >= 5) || 'El Nit debe ser mas de 5 Caracteres',
        maxValue: (str) => (!!str && str.length <= 25) || 'El Nit No debe  ser mas de 25 Caracteres',
        onlyNumbers: (v) => /^([0-9]+)$/.test(v) || 'Debe ser Solo Numeros',
      },
      menu_name: process.env.VUE_APP_NAME_MENU,
      api_rest: process.env.VUE_APP_API_REST,

      dialog: false,
      formValid: true,
      menu1: false,
      recibo: null,
      date: new Date().toISOString().substr(0, 10),
      form: {
        id: null,
        fecha_pago: null,
        nombre_depositante: null,
        num_doc_depositante: null,
        num_comprobante: null,
        forma: null,
        cuenta: null,
      },
      cuentas_bancarias: [],
      formas_pago: [
        //FIXME: this array is static
        { id: 1, nombre: 'Efectivo', descripcion: 'Pago realizado con dinero efectivo' },
        { id: 2, nombre: 'Transferencia - Depósito - Tigo Money', descripcion: 'Trasferencia realizada a travez de Tigo Money o entidad Bancaria' },
      ],
      forma_pago_original: null,
    };
  },
  watch: {
    date(value) {
      this.form.fecha_pago = formatDate(value);
    },
    'form.forma': function (value) {
      if (value && value.id === 1) {
        this.form.num_comprobante = null;
        this.form.cuenta = null;
      }
    },
  },
  methods: {
    async showThisView(recibo = null) {
      if (recibo) {
        this.recibo = await this.getPagoInscripcion(recibo.id);
        this.formatData(this.recibo);
      }
      this.dialog = true;
    },
    getPrograma(inscripcion_id) {
      const url = `${this.api_rest}/api/esam/inscripcion/id/${inscripcion_id}`;
      let url2 = `${this.api_rest}/esam/programa/id/`;
      return xaxios
        .get(url)
        .then(({ data }) => xaxios.get(url2 + data.programa_id).then(({ data }) => (data.sucursal_id ? data.sucursal_id : null)))
        .catch(() => null);
    },
    getPagoInscripcion(id) {
      const sql = gql`query{getPagoInscripcion(id: ${id}) { id,nombre_depositante,num_doc_depositante,nro_recibo,
          cuenta_bancaria_id,sede_id,fecha_pago,fecha_registro,estado,num_comprobante,factura_id,forma_pago_id,
          factura{id}
          detalle_pago{id, concepto, monto}
          sede{id, nombre cuentasBancarias {id,nombre,descripcion,nro}}      
      }}`;
      return this.$apollo
        .query({ query: sql })
        .then(({ data }) => {
          window.console.log('WILVER>> ',data);
          return data.getPagoInscripcion;
        })
        .catch(() => null);
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async saveForm() {
      const iduser = this.$store.state.DATA_USER.id;
      if(iduser==-43){
        await this.sleep(4000); 
        this.$root.$notify.show(`Access denied`, {color:'black',x: 'right',});
        return;
      }

      if(this.forma_pago_original){
        let forma_pago_id = this.form.forma ? this.form.forma.id : -1;
        if((this.forma_pago_original.id != forma_pago_id) && forma_pago_id != -1){
          this.$root.$notify.show(`No puede cambiar la forma de pago a otra distinta`, { color: 'red' });
          return;
        }
      }
      if (this.$refs.vform.validate()) {
        if (await this.$root.$confirm.open('Guardar Datos de Recibo', 'Estas seguro?', { color: 'red' })) {
          const input = {
            id: this.form.id,
            forma_pago_id: this.form.forma ? this.form.forma.id : 1,
            fecha_pago: this.date,
            nombre_depositante: this.form.nombre_depositante,
            num_doc_depositante: this.form.num_doc_depositante,
            num_comprobante: this.form.num_comprobante,
            cuenta_bancaria_id: this.form.cuenta ? this.form.cuenta.id : null,
          };
          const sql = gql`mutation{ updatePagosInscripcion(input:${window.stringifyObject(input)})
            { ok,pagos_ins{id, forma_pago_id, fecha_pago, nombre_depositante, num_comprobante, cuenta_bancaria_id, num_doc_depositante} errors{message}} }`;
          // window.console.log('POST DATA FOR SEND', sql.loc.source.body, JSON.stringify(sql.loc.source.body));
          this.$apollo
            .mutate({ mutation: sql })
            .then(({ data: { updatePagosInscripcion } }) => {
              // window.console.log(JSON.stringify(updatePagosInscripcion));
              if (updatePagosInscripcion.ok) {
                this.closeDialog();
                this.$root.$notify.show(`Recibo Editado Correctamente`, { color: 'success' });
                this.$emit('closeDialog');
              } else {
                updatePagosInscripcion.errors.forEach((e) => this.$root.$notify.show(`${e.message}`, { color: 'amber' }));
              }
            })
            .catch(() => this.$root.$notify.show(`El recibo no se puede editar`, { color: 'amber' }));
        }
      }
    },
    maxDate() {
      return new Date().toISOString().substr(0, 10);
    },
    formatData(recibo) {
      this.form.id = recibo.id;
      this.form.forma = this.formas_pago.find((f) => f.id === recibo.forma_pago_id);
      this.date = recibo.fecha_pago;
      this.cuentas_bancarias = recibo.sede.cuentasBancarias.map((cb) => ({ ...cb, nombre: `${cb.nombre} - ${cb.nro}` }));
      this.form.fecha_pago = formatDate(recibo.fecha_pago);
      this.form.nombre_depositante = recibo.nombre_depositante;
      this.form.num_doc_depositante = recibo.num_doc_depositante;
      this.form.num_comprobante = recibo.num_comprobante;
      this.form.cuenta = this.cuentas_bancarias.find((cb) => cb.id === recibo.cuenta_bancaria_id);
      this.forma_pago_original = this.form.forma;
      return;
    },
    closeDialog() {
      this.dialog = false;
      this.recibo = null;
      this.formValid = true;
      this.menu1 = false;
      this.date = new Date().toISOString().substr(0, 10);
      this.form = {
        id: null,
        fecha_pago: null,
        nombre_depositante: null,
        num_doc_depositante: null,
        num_comprobante: null,
        sucursal_id: null,
        forma: null,
        cuenta: null,
      };
      this.cuentas_bancarias = [];
    },
  },
};
</script>

<style>
</style>